import { useTranslation } from 'react-i18next'
import { PillMultiSelect } from './PillMultiSelect'

export type BranchOption = { id: number; name: string }

interface BranchMultiSelectProps {
  branches: BranchOption[]
  selectedIds: number[]
  onChange: (ids: number[]) => void
  disabled?: boolean
  className?: string
}

/** Branch picker: a field showing selected branches as removable pills (or a
 *  single "All Branches" pill when everything is selected), opening a
 *  checkbox list on click — "All Branches" sits pinned above the individual
 *  branches and toggles every branch at once. Shared by the invite dialog,
 *  the edit-user dialog and the product editor in every app.
 *
 *  The control itself is PillMultiSelect; this only supplies the branch
 *  wording, so the add-on picker beside it in the product editor can be the
 *  same control without being called a branch picker. */
export function BranchMultiSelect({
  branches, selectedIds, onChange, disabled, className,
}: BranchMultiSelectProps) {
  const { t } = useTranslation()
  return (
    <PillMultiSelect
      options={branches}
      selectedIds={selectedIds}
      onChange={onChange}
      disabled={disabled}
      className={className}
      placeholder={t('branches.selectBranches', 'Select branches')}
      allLabel={t('branches.allBranches', 'All Branches')}
    />
  )
}
